import React from "react";

import Grid from "@mui/material/Grid";

import DonationDetail from "../DonationCard/DonationDetail";
import { ComponentType } from "../../../common/enum";

const DonationHeader = ({ t }) => {
  return (
    <Grid container spacing={1} sx={{ px: 2 }}>
      <Grid item xs={10} sx={{ display: "flex" }}>
        <DonationDetail
          id={t("donationId")}
          donationType={t("type")}
          periodo={t("period")}
          reserva={t("collections")}
          componentType={ComponentType.DONATION_HEADER}
          t={t}
        />
      </Grid>
    </Grid>
  );
};

export default DonationHeader;
